import { render, staticRenderFns } from "./SQLinquire copy.vue?vue&type=template&id=1605817a&scoped=true&"
import script from "./SQLinquire copy.vue?vue&type=script&lang=js&"
export * from "./SQLinquire copy.vue?vue&type=script&lang=js&"
import style0 from "./SQLinquire copy.vue?vue&type=style&index=0&id=1605817a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1605817a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1605817a')) {
      api.createRecord('1605817a', component.options)
    } else {
      api.reload('1605817a', component.options)
    }
    module.hot.accept("./SQLinquire copy.vue?vue&type=template&id=1605817a&scoped=true&", function () {
      api.rerender('1605817a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/SQLinquire copy.vue"
export default component.exports